import React from 'react';
import Alert from '@amzn/awsui-components-core/alert';
import Button from '@amzn/awsui-components-core/button';

interface Props {
    children: React.ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error('[ErrorBoundary] Uncaught error:', error, info.componentStack);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '48px', maxWidth: '800px', margin: '0 auto' }}>
                    <Alert
                        type="error"
                        header="Something went wrong"
                        action={
                            <Button onClick={this.handleReset}>Try again</Button>
                        }
                    >
                        An unexpected error occurred. If the problem persists, try refreshing the page.
                        {this.state.error && (
                            <pre style={{ marginTop: '8px', fontSize: '12px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {this.state.error.message}
                            </pre>
                        )}
                    </Alert>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
